/** Draft registry routes are only routed in previews (VITE_INCLUDE_DRAFTS=true). */
export const INCLUDE_DRAFTS = import.meta.env.VITE_INCLUDE_DRAFTS === "true";
